(function () {
  'use strict';
  angular.module('vcdms.vcfile')
    .component('patfileupload', {
      restrict: 'E',
      bindings: {
        patientid: '<?'
      },
      template: `
        <fileupload parentsave="vm.savewithsigning(filedata)"
            label="Hinaufladen mit Vidierung"
            color="success"
            clientid="vm.patientid"
            method="vidieren">
        </fileupload>
        <fileupload parentsave="vm.savewithoutsigning()"
            label="Hinaufladen ohne Vidierung"
            color="warning"
            clientid="vm.patientid"
            method="nichtvidieren">
        </fileupload>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'File', 'Rlog',
        function ($log, File, Rlog) {
          let vm = this;
          vm.savewithsigning = savewithsigning;
          vm.savewithoutsigning = savewithoutsigning;

          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.clientid) &&
              angular.isDefined(changes.clientid.currentValue) &&
              changes.clientid.currentValue.length > 0) {
              vm.patientid = changes.clientid.currentValue;
              vm.clientid = changes.clientid.currentValue;
            }
          };

          function savewithsigning(filedata) {
            File.$find(filedata.fileid).$then(function (file) {
              $log.debug('save filewithsigning: ', file);
/*              file.scanstatus = 'assigned';
              file.signedoff = 'false';
              file.doccat = 'patient';
              file.active = true;
              file.$save().$then(()=>{},(err)=>{
                $log.error('fileupload metdata for vidierung could not be saved: ', err);
                Rlog.error('vcdms.file', 'patfileupload', 'fileupload metdata for vidierung could not be saved', {file: file._id});

              });*/
            }, function (err) {
              $log.error('fileupload metdata could not be retrieved for further editing: ', err);
              Rlog.error('vcdms.file', 'patfileupload', 'fileupload metdata could not be retrieved for further editing', {});
            });


          }

          function savewithoutsigning() {
            $log.debug('saved without vidieren');
            // do nothing, defaults are set for patient fileupload without vidierung
          }


        }] // controller
    }); // component

// klammerfriedhof
}());
